import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const MainBox = styled.div(() => ({
  backgroundColor: myPalette.aliceBlue.main,
  width: '100%',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
}))

export const PageHeader = styled.div(() => ({
  backgroundColor: myPalette.midnightBlue.main,
  color: myPalette.white.main,
  height: '293px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const ContentWrapper = styled.div(() => ({
  backgroundColor: myPalette.aliceBlue.main,
  borderRadius: '20px 20px 0 0',
  padding: '16px',
  marginTop: '-20px',
  overflow: 'auto',
  paddingBottom: '80px',
}))
